import React from 'react';

const About = () => {
  const stats = [
    { number: '5+', label: 'Years Experience' },
    { number: '24/7', label: 'Support' }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Riverside AI</h2>
        <div className="about-content">
          <div className="about-text">
            <p>Founded in 2024, Riverside AI was created with a clear vision: to empower businesses of all sizes to harness the transformative power of AI. We believe that cutting-edge AI shouldn't be exclusive to large corporations; it should be an accessible tool for every ambitious enterprise looking to innovate and thrive.</p>
            <p>At Riverside AI, we don't just deliver technology; we deliver solutions that drive measurable business value and provide a real competitive advantage. Our team comprises seasoned data scientists, innovative engineers, and pragmatic business strategists who work collaboratively to understand your unique challenges and opportunities.</p>
            <p>Embrace AI to revolutionize your customer support, supercharge your lead generation, and automate your workflows. From enhancing efficiency to unlocking new growth avenues, we guide you through every step of your AI journey.</p>
          </div>
          <div className="stats">
            {stats.map((stat, index) => (
              <div className="stat-item" key={index}>
                <span className="stat-number">{stat.number}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 